import {server} from '../Data/BuildEnvironment'
import {buildUrl} from '../Data/Http'
import {HttpRequest} from '../Data/HttpRequest'
import * as ProductCalculationCreate from '../Entities/ProductCalculationCreate'
import * as ProductCalculationUpdate from '../Entities/ProductCalculationUpdate'
import {ProductCalculationImportFormular} from '../Pages/ProductCalculationImport/ProductCalculationImportState'

export function create(
    values: ProductCalculationCreate.M,
): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/product-calculations`,
        headers: {
            'Accept': 'application/json',
        },
        body: JSON.stringify(values)
    }
}

export function prepareImportData(manufacturerId: number): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/product-calculation-import-prepare-data`,
                {}),
        headers: {
            'Accept': 'application/json',
        },
    }
}

export function listMessageSuggestions(
    manufacturer: number,
    key: string,
    value: string,
): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturer}/product-calculation-message-autosuggest`,
                {key, value},
            ),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }
}

export function listMultiMessageSuggestions(
    manufacturer: number,
    attributes: ProductCalculationImportFormular
): HttpRequest {
    return {
        verb: 'POST',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturer}/product-calculation-message-autosuggest-list`,
                {}),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            type: attributes.type.input,
            format: attributes.format.input,
            coverage: attributes.coverage.input,
            print: attributes.print.input,
            paper: attributes.paper.input,
            processing: attributes.processing.input
        })
    }
}

export function retrieve(id: number): HttpRequest {
    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/product-calculations/${id}`,
                {}),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }
}

export function update(
    id: number,
    values: ProductCalculationUpdate.M,
): HttpRequest {
    return {
        verb: 'POST',
        url: buildUrl(`${server}/product-calculations/${id}`, {}),
        headers: {
            'Accept': 'application/json',
        },
        body: JSON.stringify(values)
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/ProductCalculationResource.ts